import { render, staticRenderFns } from "./serdetail.vue?vue&type=template&id=0b454dd6&"
import script from "./serdetail.vue?vue&type=script&lang=js&"
export * from "./serdetail.vue?vue&type=script&lang=js&"
import style0 from "./serdetail.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports